var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlusWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "iconPlusWhite_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 282",
    fill: "none",
    d: "M0 0h36v36H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#iconPlusWhite_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.545 14.727H21.273V2.455A2.455 2.455 0 0018.818 0h-1.636a2.455 2.455 0 00-2.455 2.455v12.272H2.455A2.455 2.455 0 000 17.182v1.636a2.455 2.455 0 002.455 2.455h12.272v12.272A2.455 2.455 0 0017.182 36h1.636a2.455 2.455 0 002.455-2.455V21.273h12.272A2.455 2.455 0 0036 18.818v-1.636a2.455 2.455 0 00-2.455-2.455zm0 0",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlusWhite);
export default __webpack_public_path__ + "static/media/iconPlusWhite.ca27b76eac25a20c.svg";
export { ForwardRef as ReactComponent };